import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import cx from 'classnames';
var propTypes = {
  children: PropTypes.any.isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var ANIMATION_STATE_CLASSES = {
  animating: 'rah-animating',
  animatingUp: 'rah-animating--up',
  animatingDown: 'rah-animating--down',
  animatingToHeightZero: 'rah-animating--to-height-zero',
  animatingToHeightAuto: 'rah-animating--to-height-auto',
  animatingToHeightSpecific: 'rah-animating--to-height-specific',
  "static": 'rah-static',
  staticHeightZero: 'rah-static--height-zero',
  staticHeightAuto: 'rah-static--height-auto',
  staticHeightSpecific: 'rah-static--height-specific'
};

function startAnimationHelper(callback) {
  var requestAnimationFrameIDs = [];
  requestAnimationFrameIDs[0] = requestAnimationFrame(function () {
    requestAnimationFrameIDs[1] = requestAnimationFrame(function () {
      callback();
    });
  });
  return requestAnimationFrameIDs;
}

function cancelAnimationFrames(requestAnimationFrameIDs) {
  requestAnimationFrameIDs.forEach(function (id) {
    return cancelAnimationFrame(id);
  });
}

var AnimationWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "AnimationWrapper",
  componentId: "VDS__sc-pr5i70-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var AccordionAnimation = /*#__PURE__*/function (_React$Component) {
  _inherits(AccordionAnimation, _React$Component);

  var _super = _createSuper(AccordionAnimation);

  function AccordionAnimation(props) {
    var _this;

    _classCallCheck(this, AccordionAnimation);

    _this = _super.call(this, props);
    _this.animationFrameIDs = [];
    var height = props.height;
    var overflow = 'hidden';
    _this.state = {
      animationStateClasses: {},
      height: height,
      overflow: overflow,
      shouldUseTransitions: false
    };
    return _this;
  }

  _createClass(AccordionAnimation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var opened = this.props.opened;

      if (opened) {
        this.contentElement.style.display = '';
      } else {
        this.contentElement.style.display = 'none';
      }

      this.animationStateClasses = _objectSpread({}, ANIMATION_STATE_CLASSES);
      var animationStateClasses = this.getStaticStateClasses(this.state.height);
      this.setState({
        animationStateClasses: animationStateClasses
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props = this.props,
          height = _this$props.height,
          opened = _this$props.opened;
      var isCurrentHeightAuto = prevState.height === 'auto';

      if (this.contentElement && height !== prevProps.height) {
        var _cx;

        this.showContent(prevState.height);
        this.contentElement.style.overflow = 'hidden';
        var contentHeight = this.contentElement.offsetHeight;
        this.contentElement.style.overflow = '';
        var newHeight = null;
        var timeoutState = {
          height: null,
          overflow: 'hidden'
        };

        if (height === 0) {
          newHeight = height;
          timeoutState.height = newHeight;
        } else {
          newHeight = contentHeight;
          timeoutState.height = 'auto';
          timeoutState.overflow = null;
        }

        if (isCurrentHeightAuto) {
          timeoutState.height = newHeight;
          newHeight = contentHeight;
        }

        var animationStateClasses = cx((_cx = {}, _defineProperty(_cx, this.animationStateClasses.animating, true), _defineProperty(_cx, this.animationStateClasses.animatingUp, prevProps.height === 'auto' || height < prevProps.height), _defineProperty(_cx, this.animationStateClasses.animatingDown, height === 'auto' || height > prevProps.height), _defineProperty(_cx, this.animationStateClasses.animatingToHeightZero, timeoutState.height === 0), _defineProperty(_cx, this.animationStateClasses.animatingToHeightAuto, timeoutState.height === 'auto'), _cx));
        var timeoutAnimationStateClasses = this.getStaticStateClasses(timeoutState.height);
        this.setState({
          animationStateClasses: animationStateClasses,
          height: newHeight,
          overflow: 'hidden',
          shouldUseTransitions: !isCurrentHeightAuto
        });
        clearTimeout(this.timeoutID);
        clearTimeout(this.animationClassesTimeoutID);

        if (isCurrentHeightAuto) {
          timeoutState.shouldUseTransitions = true;
          cancelAnimationFrames(this.animationFrameIDs);
          this.animationFrameIDs = startAnimationHelper(function () {
            _this2.setState(timeoutState);
          });
          this.animationClassesTimeoutID = setTimeout(function () {
            _this2.setState({
              animationStateClasses: timeoutAnimationStateClasses,
              shouldUseTransitions: false
            });

            _this2.hideContent(timeoutState.height);
          }, 350);
        } else {
          this.timeoutID = setTimeout(function () {
            timeoutState.animationStateClasses = timeoutAnimationStateClasses;
            timeoutState.shouldUseTransitions = false;

            _this2.setState(timeoutState);

            if (height !== 'auto') {
              _this2.hideContent(newHeight);
            }
          }, 350);
        }
      } // wait until is callapsed to change the overflow to visible.


      if (prevProps.opened !== opened && opened && isCurrentHeightAuto) {
        this.overflowTimeoutId = setTimeout(function () {
          _this2.setState({
            overflow: 'visible'
          });
        }, 0);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cancelAnimationFrames(this.animationFrameIDs);
      clearTimeout(this.timeoutID);
      clearTimeout(this.animationClassesTimeoutID);
      clearTimeout(this.overflowTimeoutId);
      this.timeoutID = null;
      this.animationClassesTimeoutID = null;
      this.animationStateClasses = null;
      this.overflowTimeoutId = null;
    }
  }, {
    key: "showContent",
    value: function showContent(height) {
      if (height === 0) {
        this.contentElement.style.display = '';
      }
    }
  }, {
    key: "hideContent",
    value: function hideContent(newHeight) {
      if (newHeight === 0) {
        this.contentElement.style.display = 'none';
      }
    }
  }, {
    key: "getStaticStateClasses",
    value: function getStaticStateClasses(height) {
      var _cx2;

      return cx((_cx2 = {}, _defineProperty(_cx2, this.animationStateClasses["static"], true), _defineProperty(_cx2, this.animationStateClasses.staticHeightZero, height === 0), _defineProperty(_cx2, this.animationStateClasses.staticHeightSpecific, height > 0), _defineProperty(_cx2, this.animationStateClasses.staticHeightAuto, height === 'auto'), _cx2));
    }
  }, {
    key: "render",
    value: function render() {
      var _cx3,
          _this3 = this;

      var children = this.props.children;
      var _this$state = this.state,
          height = _this$state.height,
          overflow = _this$state.overflow,
          animationStateClasses = _this$state.animationStateClasses,
          shouldUseTransitions = _this$state.shouldUseTransitions;
      var componentStyle = {
        height: height,
        overflow: this.state.overflow,
        transition: 'height 350ms ease'
      };
      var contentStyle = {
        transition: 'opacity 350ms ease'
      };

      if (height === 0) {
        contentStyle.opacity = 0;
      }

      var componentClasses = cx((_cx3 = {}, _defineProperty(_cx3, animationStateClasses, true), _defineProperty(_cx3, "VDS__", true), _cx3));
      return /*#__PURE__*/React.createElement("div", {
        "aria-hidden": height === 0,
        className: componentClasses,
        style: componentStyle
      }, /*#__PURE__*/React.createElement("div", {
        style: contentStyle,
        ref: function ref(el) {
          if (el) _this3.contentElement = el;
        }
      }, children));
    }
  }]);

  return AccordionAnimation;
}(React.Component);

AccordionAnimation.propTypes = propTypes;
export default AccordionAnimation;